module.exports = "/static/fonts/OpenSans-Bold.ttf";